



















































import Vue from 'vue'
import Component from 'vue-class-component'
import { Injector } from '@/config/dependency-injection'
import { HomeUpdateRequest } from '@/api/generated'
import { NotificationService } from '@/shared/services/notification-service'
import RespondecoStepper from '@/shared/components/respondeco-stepper.vue'
import RespondecoStep from '@/shared/components/respondeco-step.vue'
import RespondecoForm from '@/shared/components/respondeco-form.vue'
import RespondecoPortfolioItem from '@/shared/components/respondeco-portfolio-item.vue'
import { AdministrationModule } from '@/business/administration/store/administration-module'
import AddOfferDialog from '@/business/administration/components/add-offer-dialog.vue'
import { OrganisationLite } from '@/business/organisation/interfaces/organisation-lite'
import HomeOffers from '@/business/administration/components/home-offers.vue'
import HomeOrganisations from '@/business/administration/components/home-organisations.vue'
import { OfferLite } from '@/business/offers/models/offer-lite'
import { Form } from '@/shared/forms/form'
import { HomeForm } from '@/business/administration/models/home-form'
import RespondecoTopBar from '@/main/respondeco-top-bar.vue'
import RespondecoSaveBar from '@/shared/components/respondeco-save-bar.vue'
import AddOrganisationDialog from '@/business/administration/components/add-organisation-dialog.vue'
import { LoaderHelper } from '@/shared/services/loader-helper'
import { UPDATE_HOME } from '@/business/administration/store/types'
import UnifyHero from '@/shared/components/unify/unify-hero.vue'
import { imageUrl } from '@/shared/utils/images'
import { MetaService } from '@/shared/services/meta-service'
import AccountOverview from '@/business/administration/components/account-overview.vue'
import { AdminService } from '@/business/administration/admin-service'

@Component({
  components: {
    UnifyHero,
    AddOrganisationDialog,
    RespondecoSaveBar,
    RespondecoTopBar,
    HomeOrganisations,
    HomeOffers,
    AddOfferDialog,
    RespondecoPortfolioItem,
    RespondecoForm,
    RespondecoStep,
    RespondecoStepper,
    AccountOverview,
  },
})
export default class Administration extends Vue {
  public form: Form<HomeUpdateRequest, HomeForm> = new Form(HomeForm, this)
  public project: string = 'home'

  private adminModule = Injector.get(AdministrationModule)
  private adminService = Injector.get(AdminService)
  private loaderHelper = Injector.get(LoaderHelper)
  private metaService = Injector.get(MetaService)
  private notificationService = Injector.get(NotificationService)

  public get saving(): boolean {
    return this.loaderHelper.isLoading(UPDATE_HOME)
  }

  public mounted() {
    this.adminService.getAccounts()

    this.adminModule
      .fetchHome({
        project: 'home',
      })
      .then(home => {
        this.form.deserialize({
          offers: home.offers.map(entry => this.mapEntry(entry)),
          organisations: home.organisations.map(entry => this.mapEntry(entry)),
        })
      })

    this.metaService.updateDocumentTitle('administration')
  }

  public addOffer(offer: OfferLite) {
    this.form.value.offers.push(this.mapEntry(offer))
  }

  public addOrganisation(organisation: OrganisationLite) {
    this.form.value.organisations.push(this.mapEntry(organisation))
  }

  public reset() {
    this.form.reset({
      offers: this.adminModule.data.offers.map(entry => this.mapEntry(entry)),
      organisations: this.adminModule.data.organisations.map(entry => this.mapEntry(entry)),
    })
  }

  public submitHome() {
    this.adminModule
      .updateHome({
        offers: this.form.value.offers.map(offer => offer.id),
        organisations: this.form.value.organisations.map(organisation => organisation.id),
        project: this.project,
      })
      .then(() => {
        this.notificationService.success()
        this.reset()
      })
      .catch(this.notificationService.errorHandler)
  }

  public updateProject() {
    this.adminModule
      .fetchHome({
        project: this.project,
      })
      .then(home => {
        this.form.deserialize({
          offers: home.offers.map(entry => this.mapEntry(entry)),
          organisations: home.organisations.map(entry => this.mapEntry(entry)),
        })
      })
  }

  private mapEntry<T extends OfferLite | OrganisationLite>(entry: T): T {
    return {
      ...entry,
      description: entry.description || '',
      image: imageUrl(entry.image, 350),
    }
  }
}
